import { useTranslation } from "next-i18next";
import { ModalProps } from "./ModalProps";
import { Modal } from "./Modal";

type Props = {
  onClose: () => void;
  primaryButtonText?: string;
} & Pick<
  ModalProps,
  "title" | "modalType" | "isOpen" | "children" | "buttonDisplay"
>;

export const InfoModal = ({
  children,
  onClose,
  isOpen,
  title,
  modalType,
  primaryButtonText,
  buttonDisplay = "inline",
}: Props) => {
  const { t } = useTranslation(["common-components"]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      modalType={modalType}
      alignment="center"
      buttonDisplay={buttonDisplay}
    >
      {children}
      <Modal.Buttons
        primaryButtonText={primaryButtonText ?? t("common-components:confirm")}
        onPrimaryClick={onClose}
      />
    </Modal>
  );
};

export default {};
